const statusLabels: Record<string, string> = {
  active: "Activa",
  trialing: "Prueba",
  past_due: "Pago pendiente",
  cancelled: "Cancelada",
  paused: "Pausada",
  suspended: "Acceso suspendido",
  paid: "Pagado",
  pending: "Pendiente",
  failed: "Fallido",
  refunded: "Reembolsado",
  ok: "Operativa",
  connected: "Conectada",
  degraded: "Con incidencias",
  down: "No disponible",
  not_configured: "Sin configurar",
  unknown: "Sin datos",
  critical: "Crítica",
  warning: "Atención",
  info: "Informativa",
  open: "Abierta",
  resolved: "Resuelta",
  dismissed: "Descartada",
  draft: "Borrador",
  purchased: "Comprado",
  in_transit: "En tránsito",
  received: "Recepcionado",
  in_preparation: "En preparación",
  available: "Disponible",
  reserved: "Reservado",
  sold: "Vendido",
  delivered: "Entregado",
  returned: "Devuelto",
  written_off: "Baja",
  new: "Nuevo",
  contacted: "Contactado",
  qualified: "Cualificado",
  appointment: "Cita",
  test_drive: "Prueba",
  offer: "Oferta",
  negotiation: "Negociación",
  financing: "Financiación",
  won: "Ganado",
  lost: "Perdido",
  yard: "Campa",
  showroom: "Exposición",
  workshop: "Taller",
  branch: "Sede",
  vehicle: "Vehículos",
  documents: "Documentación",
  commercial: "Clientes y ventas",
  sales: "Ventas",
  transfer: "Transferencias",
  publishing: "Publicación",
  system: "Sistema",
  billing: "Suscripción",
  fiscal: "Fiscalidad",
  dgt_intv: "DGT",
  transactional_email: "Correo transaccional",
  web_push: "Avisos en el navegador",
  cloudflare_email: "Recepción de correo",
  stripe: "Cobros con Stripe",
  core: "Gestión de vehículos",
  crm: "Clientes y oportunidades",
  showcase: "Escaparate público",
  photo_studio: "Estudio fotográfico",
  transfers: "Cambios de titularidad",
  analytics: "Analítica del negocio",
  multi_site: "Varias sedes",
  priority_support: "Soporte prioritario",
  photo_pack_500: "Pack de edición de fotografías",
  transfer_service: "Servicio de cambio de titularidad",
  vehicles: "Vehículos",
  users: "Personas del equipo",
  photo_processing: "Fotografías procesadas",
  automatic_responses: "Respuestas automáticas",
  ai_calls: "Consultas de inteligencia artificial",
  storage_bytes: "Almacenamiento",
  browser: "Aplicación web",
  client: "Aplicación web",
  api: "Servicio de Cochegest",
  manual: "Ajuste manual",
  purchase: "Compra",
  subscription: "Suscripción",
};

const roleLabels: Record<string, string> = {
  owner: "Propietario",
  admin: "Administración",
  sales: "Comercial",
  office: "Oficina",
  mechanic: "Taller",
  external_manager: "Gestoría externa",
  readonly: "Solo lectura",
};

const notificationRuleCopies: Record<string, { name: string; description: string }> = {
  ocr_review_pending: {
    name: "Documento pendiente de revisión",
    description: "Los datos extraídos del documento esperan una revisión.",
  },
  lead_first_response: {
    name: "Nueva consulta sin respuesta",
    description: "Una nueva consulta sigue sin recibir atención.",
  },
  transfer_sla: {
    name: "Transferencia fuera de plazo",
    description: "El trámite enviado no se ha completado dentro del plazo previsto.",
  },
  integration_degraded: {
    name: "Servicio conectado con incidencias",
    description: "Uno de los servicios conectados está fallando.",
  },
  client_error_spike: {
    name: "Aumento de errores en la aplicación",
    description: "Se han detectado varios errores en la aplicación en poco tiempo.",
  },
};

const actionLabels: Record<string, string> = {
  "tenant.create": "Concesionario creado",
  "product.update": "Producto actualizado",
  "plan.update": "Plan actualizado",
  "subscription.update": "Suscripción actualizada",
  "notification_rule.update": "Regla de aviso actualizada",
  "notifications.run": "Automatizaciones ejecutadas",
  "credits.adjust": "Saldo de fotografías ajustado",
  "fiscal_parameter.create": "Parámetro fiscal versionado",
  "zbe_zone.put": "Zona de bajas emisiones guardada",
  "vehicle.create": "Vehículo dado de alta",
  "vehicle.created": "Vehículo dado de alta",
  "vehicle.updated": "Ficha del vehículo actualizada",
  "vehicle.price_changed": "Precio del vehículo actualizado",
  "vehicle.status_changed": "Estado del vehículo actualizado",
  "vehicle.transition": "Vehículo avanzado de estado",
  "vehicle.move": "Ubicación del vehículo actualizada",
  "purchase.register": "Compra registrada",
  "supplier.register": "Proveedor registrado",
  "supplier.reclassify": "Proveedor reclasificado",
  "vehicle.tax_flow.override": "Régimen fiscal revisado",
  "vehicle.cost.record": "Coste del vehículo registrado",
  "vehicle.cost.reverse": "Coste del vehículo revertido",
  "sale.create": "Venta creada",
  "sale.reopen": "Venta reabierta",
  "sale.cancel": "Venta cancelada",
  "sale.deliver": "Vehículo entregado",
  "invoice.issue": "Factura emitida",
  "invoice.annul": "Factura anulada",
  "appraisal.create": "Tasación creada",
  "appraisal.convert": "Tasación convertida en compra",
  "lead.create": "Oportunidad creada",
  "lead.status.update": "Oportunidad actualizada",
  "workshop.order.create": "Orden de taller creada",
  "workshop.order.complete": "Orden de taller completada",
  "publication.create": "Publicación creada",
  "publication.action.request": "Sincronización de anuncio solicitada",
};

const entityLabels: Record<string, string> = {
  tenant: "Concesionario",
  platform: "Plataforma",
  platform_product: "Producto",
  plan: "Plan",
  subscription: "Suscripción",
  notification_rule: "Regla de aviso",
  fiscal_parameter: "Parámetro fiscal",
  zbe_zone: "Zona de bajas emisiones",
  vehicle: "Vehículo",
  sale: "Venta",
  invoice: "Factura",
  purchase: "Compra",
  supplier: "Proveedor",
  appraisal: "Tasación",
  lead: "Oportunidad",
  workshop_order: "Orden de taller",
  publication: "Publicación",
  document: "Documento",
};

const tokenLabels: Record<string, string> = {
  vehicle: "vehículo",
  sale: "venta",
  invoice: "factura",
  purchase: "compra",
  supplier: "proveedor",
  appraisal: "tasación",
  lead: "oportunidad",
  workshop: "taller",
  publication: "publicación",
  document: "documento",
  create: "creado",
  created: "creado",
  update: "actualizado",
  updated: "actualizado",
  change: "cambiado",
  changed: "cambiado",
  complete: "completado",
  completed: "completado",
  cancel: "cancelado",
  cancelled: "cancelado",
  register: "registrado",
  registered: "registrado",
  issue: "emitida",
  annul: "anulada",
  status: "estado",
  price: "precio",
  cost: "coste",
  transition: "cambio de estado",
  move: "ubicación",
};

function readableCode(value: string): string {
  const words = value.trim().toLowerCase().split(/[._-]+/).filter(Boolean).map((part) => tokenLabels[part] ?? part);
  if (!words.length) return "Sin clasificar";
  const label = words.join(" ");
  return `${label.charAt(0).toLocaleUpperCase("es-ES")}${label.slice(1)}`;
}

export function statusLabel(value: string): string {
  const normalized = value.trim().toLowerCase();
  if (!normalized) return "Sin datos";
  return statusLabels[normalized] ?? readableCode(normalized);
}

export function roleLabel(value: string): string {
  const normalized = value.trim().toLowerCase();
  return roleLabels[normalized] ?? statusLabel(normalized);
}

export function notificationRulePresentation(code: string, fallbackName: string, fallbackDescription: string): { name: string; description: string } {
  return notificationRuleCopies[code.trim().toLowerCase()] ?? {
    name: fallbackName,
    description: fallbackDescription,
  };
}

export function activityLabel(value: string): string {
  const normalized = value.trim().toLowerCase();
  return actionLabels[normalized] ?? readableCode(normalized);
}

export function entityLabel(value: string): string {
  const normalized = value.trim().toLowerCase();
  return entityLabels[normalized] ?? readableCode(normalized);
}

export function integrationSummary(status: string, hasError: boolean): string {
  if (status === "down") return "El servicio no está disponible";
  if (status === "degraded") return "Funciona con incidencias";
  if (status === "not_configured") return "Pendiente de configurar";
  if (hasError) return "Requiere revisión";
  return "Sin incidencias registradas";
}

export function integrationLastCheckLabel(status: string, lastSuccessAt: string | null | undefined, hasError: boolean): string {
  if (["ok", "connected"].includes(status) && lastSuccessAt) return "Última comprobación correcta";
  return integrationSummary(status, hasError);
}

export function fiscalIntegerFromDisplay(value: string, unit: "cents" | "bps" | "months" | "days" | "count" | undefined): number {
  const parsed = Number(value);
  if (unit === "cents" || unit === "bps") return Math.round(parsed * 100);
  return Math.round(parsed);
}
